import api from './api'

export default {
  getCourses(size, page, sort) {
    size = size || 12
    page = page || 0
    return api.get(
      `xapi/dashboard/courses?size=${size}&page=${page}&sort=${sort}`,
      { crossdomain: true }
    )
  },
  getCourse(id) {
    return api.get(`xapi/dashboard/courses/${id}`, { crossdomain: true })
  },
  getAllAgentCourses(agentId) {
    return api.get(`xapi/dashboard/courses/agent/${agentId}`, {
      crossdomain: true
    })
  },
  getCourseFailedScores(id) {
    return api.get(`xapi/dashboard/courses/${id}/failed`, {
      crossdomain: true
    })
  },
  getCoursePassedScores(id) {
    return api.get(`xapi/dashboard/courses/${id}/passed`, {
      crossdomain: true
    })
  },
  getCourseEvent(id) {
    return api.get(`xapi/dashboard/courses/${id}/event`, {
      crossdomain: true
    })
  },
  getCourseTimed(id) {
    return api.get(`xapi/dashboard/courses/${id}/timed`, {
      crossdomain: true
    })
  },
  search(search) {
    return api.get(`xapi/dashboard/search?search=${search}`, {
      crossdomain: true
    })
  }
}
